import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { S3_SM_TRANNING_DOC_FOLDER } from 'helpers/urlHelper';

import DocumentBaseModal from './DocumentBaseModal';
const LessonDocumentModal = ({
  isShow,
  handleClose,
  onSubmit,
  skillLevelId,
  sectionId,
  areaId
}) => {
  const app = 'sm.training.doc';
  const title = 'Lesson Documents';
  const [documentFolder, setDocumentFoloder] = useState('');
  const [recordValue, setRecordValue] = useState('');

  useEffect(() => {
    if (sectionId && areaId && skillLevelId) {
      setDocumentFoloder(
        S3_SM_TRANNING_DOC_FOLDER +
          `/Section/${sectionId}/Area/${areaId}/SkillLevel/${skillLevelId}`
      );

      setRecordValue(`${sectionId}_${areaId}_${skillLevelId}`);
    }
  }, [skillLevelId, sectionId, areaId]);
  return (
    <DocumentBaseModal
      isShow={isShow}
      handleClose={handleClose}
      onSubmit={onSubmit}
      app={app}
      recordValue={recordValue}
      documentFolderParam={documentFolder}
      title={title}
    />
  );
};
LessonDocumentModal.propTypes = {
  isShow: PropTypes.bool,
  handleClose: PropTypes.func,
  onSubmit: PropTypes.func,
  skillLevelId: PropTypes.number.isRequired,
  sectionId: PropTypes.number.isRequired,
  areaId: PropTypes.number.isRequired
};

export default LessonDocumentModal;
